import { frontendURL } from 'dashboard/helper/URLHelper';

export const crmRoutes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm_board',
    component: () => import('./CrmBoard.vue'),
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  // custom (Metas · F4): a Home do Operador ("Início") NÃO vive mais aqui — virou
  // rota top-level (accounts/:accountId/inicio) em ./inicio.routes.js, 1º item da
  // sidebar e landing de entrada de todos os usuários. Não é um item do CRM.
  {
    path: frontendURL('accounts/:accountId/crm/metrics'),
    name: 'crm_metrics',
    component: () => import('./CrmMetrics.vue'),
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  // custom (CRM v2 · Fase 2): Funis — lista + Tela A (config). Admin-only:
  // a config de funil só existe para administradores (spec 1.1 / 1.2). Os dois
  // papéis veem Pipeline e Métricas; só admin vê Funis. O gate de papel também
  // vive na sidebar (esconde o sub-item) e no backend (Pundit) — aqui é defesa
  // em profundidade no router.
  // custom (2026-08-06): SETORES — o nível acima das trilhas. Setor é o
  // departamento do negócio (Inside Sales, Prospecção Ativa, RH); as trilhas
  // vivem dentro dele. É aqui que o item "Setores" da sidebar chega; antes ele
  // ia para a lista de funis, que agora são as trilhas — a tela mentia.
  {
    path: frontendURL('accounts/:accountId/crm/sectors'),
    name: 'crm_sectors',
    component: () => import('./CrmSectorList.vue'),
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/crm/funnels'),
    name: 'crm_funnels',
    component: () => import('./CrmFunnelList.vue'),
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/crm/funnels/:funnelId'),
    name: 'crm_funnel_config',
    component: () => import('./CrmFunnelConfig.vue'),
    meta: {
      permissions: ['administrator'],
    },
  },
  // custom (Metas · F3): Administração de Metas. Admin-only — defesa em
  // profundidade (rota + sidebar isAdmin + Pundit no backend). pt-BR locked.
  {
    path: frontendURL('accounts/:accountId/crm/metas'),
    name: 'crm_metas_admin',
    component: () => import('./CrmMetasAdmin.vue'),
    meta: {
      permissions: ['administrator'],
    },
  },
  // custom (2026-06-26): Equipe interna — blocklist de internos + limpeza de cards.
  // Admin-only: defesa em profundidade (rota + sidebar isAdmin + Pundit no backend).
  {
    path: frontendURL('accounts/:accountId/crm/equipe-interna'),
    name: 'crm_internal_blocklist',
    component: () => import('./CrmInternalBlocklist.vue'),
    meta: {
      permissions: ['administrator'],
    },
  },
];
